import { IconProps } from '.';

const PriceIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="price">
        <path
          id="Vector 53 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6893 3.8275L21.8811 13.7594L12.1081 23.5324L0.984369 12.4087L10.7574 2.63567L20.6893 3.8275ZM11.3025 4.21185L3.10569 12.4087L12.1081 21.4111L20.3049 13.2143L19.3404 5.1764L11.3025 4.21185Z"
          fill={color || 'white'}
        />
        <path
          id="Ellipse 53"
          d="M16.82 11.0659C15.9413 11.9446 14.5167 11.9446 13.638 11.0659C12.7593 10.1873 12.7593 8.76264 13.638 7.88396C14.5167 7.00528 15.9413 7.00528 16.82 7.88396C17.6986 8.76264 17.6986 10.1873 16.82 11.0659Z"
          fill={color || 'white'}
        />
      </g>
    </svg>
  );
};

export default PriceIcon;
